import TabInfo from '../../../common/TabController/TabInfo';
import NewMdJob from './NewMdJob';
import MdJobs from './MdJobs';
import MdResults from './MdResults';

const tabs = [
    new TabInfo(
        'new_md_tab',
        'New Job',
        NewMdJob,
        {
            TabPanelProps: { sx: { p: 1 } }, // override padding level
        }
    ),
    new TabInfo(
        'md_jobs_tab',
        'Jobs',
        MdJobs,
        {
            TabPanelProps: { sx: { p: 1 } }, // override padding level
        }
    ),
    new TabInfo(
        'md_results_tab',
        'Results',
        MdResults,
        {
            TabPanelProps: {
                style: {
                    flex: 1,
                    flexDirection: 'column',
                },
                sx: { p: 1 }, // override padding level
            },
        }
    ),
];
export default tabs;
